(function () {

  function applyThreeUp(container) {
    var grid = container.querySelector(".gridDiv");
    if (!grid) return;

    var selectedBox = container.querySelector(".gfgGridBox.gfgGridBoxSelected[discount-tier]");
    if (!selectedBox) return;

    var sel = parseInt(selectedBox.getAttribute("discount-tier"), 10);
    if (!isFinite(sel)) return;

    var boxes = Array.prototype.slice.call(
      container.querySelectorAll('.gfgGridBox[discount-tier]')
    );

    var keep = {};
    keep[sel - 1] = true;
    keep[sel] = true;
    keep[sel + 1] = true;

    boxes.forEach(function (b) {
      var t = parseInt(b.getAttribute("discount-tier"), 10);
      if (keep[t]) b.classList.remove("is-hidden-tier");
      else b.classList.add("is-hidden-tier");
    });

    container.style.setProperty("--gfg-tier-row", selectedBox.offsetHeight + "px");

    var gridRect = grid.getBoundingClientRect();
    var boxRect = selectedBox.getBoundingClientRect();
    var currentScroll = grid.scrollTop;
    var boxOffsetInGrid = (boxRect.top - gridRect.top) + currentScroll;

    var target = boxOffsetInGrid - (grid.clientHeight / 2) + (selectedBox.clientHeight / 2);
    grid.scrollTo({ top: target, behavior: "smooth" });
  }

  function initContainer(container) {
    if (!container || container.__kite3upInit) return;
    container.__kite3upInit = true;

    var observer = new MutationObserver(function () {
      requestAnimationFrame(function () {
        applyThreeUp(container);
      });
    });

    observer.observe(container, { childList: true, subtree: true });

    container.addEventListener("click", function (e) {
      if (e.target.closest(".gfgGridBox[discount-tier]")) {
        requestAnimationFrame(function () {
          applyThreeUp(container);
        });
      }
    }, true);

    applyThreeUp(container);
  }

  function boot() {
    var containers = document.querySelectorAll(".gfgVolDiscountContainer.gfgCountDiscount");
    containers.forEach(initContainer);
  }

  function waitForWidget() {
    var tries = 0;
    var timer = setInterval(function () {
      boot();
      tries++;
      if (tries > 50) clearInterval(timer);
    }, 300);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForWidget);
  } else {
    waitForWidget();
  }

  document.addEventListener("shopify:section:load", waitForWidget);

})();